/**
 * Build-time brand values from REACT_APP_* (set by apply-brand / .env.production).
 * Falls back to ESS defaults for local development.
 */
const brand = {
  id: process.env.REACT_APP_BRAND_ID || "ess",
  appName: process.env.REACT_APP_APP_NAME || "ESS HRMS",
  shortName: process.env.REACT_APP_BRAND_SHORT || "ESS",
  version: process.env.REACT_APP_VERSION || "1.0.0",
  primaryColor: process.env.REACT_APP_PRIMARY_COLOR || "#293681",
  secondaryColor: process.env.REACT_APP_SECONDARY_COLOR || "#4274D9",
  primaryDarkColor: process.env.REACT_APP_PRIMARY_DARK || "#1a2454",
};

export default brand;
